import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { IAppointmentData, IAppointmentRemarks } from 'src/app/models/IAppointmentDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Defaults } from 'src/app/Utilities/defaults';
import { stringify } from 'querystring';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';

export interface DialogData {
  Comments: string;
  adminUser: string;
  screen: string;
  appid: string;
}

export class PeriodicElement {
  chked: string;
  code: string;
  color: string;
  remarks: string;
}
@Component({
  selector: 'app-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class RemarksComponent implements OnInit {
  columnsToDisplay = ['chked', 'code', 'color', 'remarks',];

  // dataSource = ELEMENT_DATA;
  Remarks: IAppointmentRemarks[] = [];
  appremarkList: IAppointmentRemarks[] = [];
  appremarkListMaster: IAppointmentRemarks[] = [];
  //ELEMENT_DATA: PeriodicElement[] = [];
  dataSource = new MatTableDataSource(this.Remarks);
  // dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  public remarksobj: PeriodicElement = new PeriodicElement();
  expandedElement: PeriodicElement | null;
  ClosePopup: boolean = false;
  remarksform: FormGroup;
  public show: boolean = false;
  public Selectedcode: string = "";
  public Existingcodes: string = "";
  public Commentids: string;
  public adminUser: string;
  public AppId: string;

  public type: string;
  public chk: string = "";
  public codes: string = "";
  public checks: string = "";

  constructor(
    public dialogRef: MatDialogRef<RemarksComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private formBuilder: FormBuilder
    , private schedulerservice: SchedularServiceService, private toastr: ToastrService
    , private spinner: NgxSpinnerService) {
    this.Commentids = data.Comments;
    this.adminUser = data.adminUser;
    this.type = data.screen;
    this.AppId = data.appid;
    this.getAppointmentRemarksList();
  }

  showInfo() {
    this.show = !this.show;

  }
  ngOnInit() {
    this.remarksform = this.formBuilder.group({

      code: ['', [Validators.required]],
      color: ['', [Validators.required]],
      description: ['', [Validators.required]],
      codes: [''],
      colors: [''],
      descriptions: [''],
    });

    this.remarksform.markAllAsTouched();
    this.remarksform.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.remarksform);
    });

  }

  getAppointmentRemarksList() {
    this.spinner.show();
    this.schedulerservice.getAppointmentsRemarks(this.AppId).subscribe(
      (app: IAppointmentRemarks[]) => {

        this.appremarkListMaster = app;
        let commentsList = this.Commentids.split(',').map(res => { return res.trim() });
        let appFilterList = app.filter(i => i.isActive == true);

        //  this.appremarkList = app
        app.filter(i => i.isActive == false).forEach(res => {
          if (commentsList.filter(i => i == res.code).length > 0)
            appFilterList.push(res);
        });

        appFilterList = appFilterList.sort((a, b) => a.code.localeCompare(b.code));
        this.appremarkList = appFilterList;

        //this.appremarkList = this.appremarkList.filter((d, l, c) => c.findIndex(x => x.remarks === d.remarks) === l);
        this.dataSource.data = this.appremarkList;
        this.fetchdata();
      },
      (err: any) => {
        this.spinner.hide();
        console.log(err)
      });

  }
  test: string;
  fetchdata() {

    this.codes = this.Commentids;
    this.Selectedcode = this.codes;
    this.Existingcodes = this.codes;
    var existcomments = this.Commentids;
    var comment_array = existcomments.split(',');


    //alert(comment_array[i])
    this.appremarkList.forEach(element => {
      for (var i = 0; i < comment_array.length; i++) {
        comment_array[i] = comment_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
        this.test = comment_array[i];
        if (element.code === this.test) {
          element.checkd = true;
        }
      }
    });
    this.dataSource = new MatTableDataSource(this.appremarkList)
    this.spinner.hide();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  btnDone_Click() {
    this.ClosePopup = true;
    this.onDoneClick();

  }
  onDoneClick() {
    if (this.type == "update" && this.Existingcodes != this.Selectedcode) {
      var selectedremarks = '';
      selectedremarks = this.removeduplicatesfromstring(this.Selectedcode);
      var RComment = selectedremarks;
      var Appointmentid = this.AppId;
      this.schedulerservice.UpdateRemarksbyId(Appointmentid, RComment).subscribe(
        results => {

          if (this.ClosePopup == false)
            this.getAppointmentRemarksList();
          else if (this.ClosePopup == true) {
            this.toastr.success(results);
            this.dialogRef.close();
          }

        }, (err: any) => {
          console.log(err);
        });
    }
    else {
      if (this.Selectedcode.length > 0) {

        var selectedremarkstr = this.removeduplicatesfromstring(this.Selectedcode);
        if (this.ClosePopup == true)
          this.dialogRef.close(selectedremarkstr);
      }
      else {
        //this.toastr.error("Please select remarks");
        if (this.ClosePopup == true)
          this.dialogRef.close("");
      }
    }
  }
  selectedremark: string = '';
  removeduplicatesfromstring(selstr: string) {
    this.selectedremark = '';
    const selstrArr = [];

    for (let i = 0; i < selstr.split(",").length; i++) {

      const val = selstr.split(",")[i].toString().trim();
      selstrArr.push(val);
    }
    selstr = selstrArr.join(",")

    if (selstr.includes(',')) {
      this.selectedremark = Array.from(new Set(selstr.split(','))).toString();
    }
    else {
      this.selectedremark = selstr.trim();
    }
    this.selectedremark = this.selectedremark.split(",").join(", ")
    return this.selectedremark;
  }
  remarksobjs: IAppointmentRemarks = new IAppointmentRemarks();
  Addremarks() {
    if (this.remarksform.value.code != "" && this.remarksform.value.description != "" && this.remarksform.value.color) {
      if (this.appremarkList.filter(i => i.code.toLowerCase() == this.remarksform.value.code.toLowerCase()).length > 0) {
        this.toastr.error("Record already exists");
        return
      }

      this.show = false;
      this.remarksobjs.code = this.remarksform.value.code;
      this.remarksobjs.color = this.remarksform.value.color;
      this.remarksobjs.remarks = this.remarksform.value.description;
      this.remarksobjs.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
      this.remarksobjs.isActive = Defaults.active;
      this.remarksobjs.dbOperation = 'Insert';
      const codeAlreadyinInactive = this.appremarkListMaster.filter(i => i.code.toLowerCase() == this.remarksobjs.code.toLowerCase() && i.isActive == false);
      if (codeAlreadyinInactive && codeAlreadyinInactive.length > 0) {
        this.remarksobjs.codeId = codeAlreadyinInactive[0].codeId;
        this.remarksobjs.dbOperation = 'UpdatetoActive';
      }

      this.schedulerservice.insertAppointmentRemarks(this.remarksobjs).subscribe(
        results => {
          this.toastr.success(results);
          this.getAppointmentRemarksList();
          this.clearformcontrolvalues();
        });
      // this.ELEMENT_DATA.push(this.remarksobj);
      // this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      // this.show = false;
      // this.remarksobj = new PeriodicElement();
      // this.clearformcontrolvalues();
    }
  }

  editremarksobjs: IAppointmentRemarks = new IAppointmentRemarks();
  editremarks(element: IAppointmentRemarks) {

    if (this.remarksform.value.codes == "" || this.remarksform.value.descriptions == "") {
      this.toastr.error("Please enter all inputs");
      return
    }

    if (this.appremarkList.filter(i => i.code.toLowerCase() == this.remarksform.value.codes.toLowerCase() && i.codeId != element.codeId).length > 0) {
      this.toastr.error("Record already exists");
      return
    }
    if (element.isInUse == false)
      this.editremarksServiceCall(element);
    else {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '400px',
        height: '160px',
        data: { headerText: "Any changes made to this 'Remark' will not effect the encounters that has this 'Remark' selected. Do you wish to continue?" }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          this.editremarksServiceCall(element);
        }
      });
    }
  }
  editremarksServiceCall(element: IAppointmentRemarks) {
    this.editremarksobjs.code = this.remarksform.value.codes;
    this.editremarksobjs.codeId = Number(element.codeId);
    this.editremarksobjs.color = this.remarksform.value.colors;
    this.editremarksobjs.remarks = this.remarksform.value.descriptions;
    this.editremarksobjs.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.editremarksobjs.isActive = Defaults.active;
    this.editremarksobjs.dbOperation = 'Update';
    this.editremarksobjs.Appointmentid = this.AppId

    if (this.remarksform.value.codes != element.code)// && element.isInUse==true)
    {
      this.editremarksobjs.dbOperation = 'DeleteAndADD';
    }
    this.schedulerservice.insertAppointmentRemarks(this.editremarksobjs).subscribe(
      (results: string) => {
        this.toastr.success(results);
        if (element.checkd && this.remarksform.value.codes != element.code && results.toLowerCase().indexOf("success") > -1) {
          var splitarray = this.Selectedcode.split(",").map(ele => { return ele.trim(); }).filter(i => i.trim() != element.code);
          // splitarray.push(this.editremarksobjs.code);
          splitarray.push(this.remarksform.value.codes);
          this.Selectedcode = splitarray.join(", ");
          this.Commentids = this.Selectedcode;
          this.ClosePopup = false;
          this.onDoneClick();
        }
        else
          this.getAppointmentRemarksList();
      });
  }
  onCancel(id: number) {
    if (id == 0) {
      this.show = false;
      this.clearformcontrolvalues();
    }
  }

  clearformcontrolvalues() {
    this.remarksform.patchValue({
      code: '',
      description: '',
      color: '',
    });
  }

  formErrors = {
    'code': '',
    'descriptionn': '',
    'color': '',
  };

  validationMessages = {
    'code': {
      'required': 'code is required.',
    },
    'description': {
      'required': 'description is required.'
    },
    'color': {
      'required': 'color is required.'
    }
  };
  logValidationErrors(group: FormGroup = this.remarksform): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  public selectedColorListCount: number = 0;
  fnShowSelectedCodeWithColor() {
    let SelectedcodeWithColor: IAppointmentRemarks[] = [];
    if (this.Selectedcode != "") {
      this.appremarkList.filter(i => this.Selectedcode.split(",").filter(j => j.trim() == i.code.trim()).length > 0).forEach(ele => {
        ele.code = ele.code.trim();
        SelectedcodeWithColor.push(ele);
      });
    }
    this.selectedColorListCount = SelectedcodeWithColor.length;
    return SelectedcodeWithColor;
  }
  selectedCPTCodes(element: IAppointmentRemarks, event: boolean, check) {
    this.checks = check;

    this.expandedElement = null;
    this.codes = element.code.trim();
    if (this.Selectedcode == null && this.Selectedcode == undefined) {
      this.Selectedcode = "";
    }
    const SelectedCodeLength: number = this.Selectedcode.split(",").filter(i => i.trim() == this.codes).length
    if (SelectedCodeLength > 0 && event == false) {
      var codes = this.Selectedcode.split(",").filter(i => i.trim() != '' && i.trim() != this.codes)
      codes.forEach(ele => { ele = ele.trim() });
      this.Selectedcode = codes.join(", ");

    }
    else if (SelectedCodeLength == 0 && event == true) {
      var codes = this.Selectedcode.split(",").filter(i => i.trim() != '');
      codes.forEach(ele => { ele = ele.trim() });
      codes.push(this.codes.trim());
      this.Selectedcode = codes.join(", ");
    }
    else {
      this.chk = this.codes;
      this.Selectedcode = this.codes;
    }
    /*
    var test = this.Selectedcode.includes(this.codes);
    if (test == true && event == false) {
      this.Selectedcode = this.Selectedcode.replace(this.codes, '');
      this.Selectedcode = this.Selectedcode.replace(",,", ',');
      this.Selectedcode = this.Selectedcode.replace(", ,", ',')
      this.Selectedcode = this.Selectedcode.replace(" ,", '')
      this.Selectedcode = this.Selectedcode.replace(/,\s*$/, "");
      if (this.Selectedcode.charAt(0) == ",") {
        this.Selectedcode = this.Selectedcode.substring(1);
      }
    } else {
      if (test == false && event == true) {
        this.Selectedcode = this.Selectedcode.concat(", " + this.codes);
        this.Selectedcode = this.Selectedcode.replace(" ,", '')
        this.Selectedcode = this.Selectedcode.replace(", ,", ',');
        this.Selectedcode = this.Selectedcode.replace(/,\s*$/, "");
        if (this.Selectedcode.charAt(0) == ",") {
          this.Selectedcode = this.Selectedcode.substring(1);
        }
      } else {
        this.chk = this.codes;
        this.Selectedcode = this.codes;
      }
      
    }*/
  }
  AlphaOnly(e: any) {
    let input = String.fromCharCode(e.charCode);
    const reg = /[a-zA-Z]+/g;
    if (!reg.test(input)) {
      e.preventDefault();
    }
  }
  canceleditremarks() {
    this.expandedElement = null;
  }
  Deleteeditremarks(element: IAppointmentRemarks) {
    let headertest = "This record will not get deleted for the encounters that has this 'Remark' selected. Do you wish to continue?"
    //'Are you sure, do you want to delete this remark?';
    // if(element.isInUse==true)
    // {
    //   headertest='Record is already in Use , do you want to delete this remark?'
    // }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      height: '160px',
      data: { headerText: headertest }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.editremarksobjs.code = element.code;
        this.editremarksobjs.codeId = Number(element.codeId);
        this.editremarksobjs.color = element.color;
        this.editremarksobjs.remarks = element.remarks;
        this.editremarksobjs.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
        this.editremarksobjs.isActive = Defaults.inActive;
        this.editremarksobjs.Appointmentid = this.AppId
        this.editremarksobjs.dbOperation = 'Delete';
        this.schedulerservice.insertAppointmentRemarks(this.editremarksobjs).subscribe(
          results => {
            if (this.Selectedcode.includes(this.codes) && element.checkd == true)
            //(this.Selectedcode.split(',').filter(i=>i.toString().trim()==element.code).length>0)
            {
              this.Selectedcode = this.Selectedcode.split(",").filter(i => i.trim() != element.code).join(", ");
              //  this.selectedCPTCodes(element,false,'check');
              this.ClosePopup = false;
              this.onDoneClick();
            }
            else
              this.getAppointmentRemarksList();
            this.toastr.success(results);

            // this.clearformcontrolvalues();
          });
      }
    });

  }
  onCellClick(element: IAppointmentRemarks) {
    this.remarksform.patchValue({
      codes: element.code,
      colors: element.color,
      descriptions: element.remarks,
    });
  }
}
